(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  // What the visitor typed, kept for the length of the visit. Shopify puts
  // back only the email and the message when it turns a submission down, so
  // the rest comes from here.
  const DRAFT = 'hc-contact-draft';

  // Outline every field that needs fixing and start on the first of them,
  // instead of the browser's own bubbles. A valid form posts as usual.
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-contact-form]');
    if (!form) return;
    if (form.checkValidity()) {
      try {
        sessionStorage.setItem(DRAFT, JSON.stringify(Object.fromEntries(new FormData(form))));
      } catch {}
      return;
    }
    event.preventDefault();
    form.dataset.tried = '';
    const status = form.querySelector('[data-status]');
    if (status) {
      status.textContent = status.dataset.invalid;
      status.hidden = false;
    }
    form.querySelector(':invalid')?.focus();
  });

  // A link from the services page can name the service it came from:
  // /pages/yhteystiedot?palvelu=verkkovalmennus.
  function setUpContactForms() {
    const wanted = new URLSearchParams(location.search).get('palvelu');
    document.querySelectorAll('[data-contact-form]').forEach((form) => {
      const select = form.querySelector('[data-service]');
      const option = wanted && select?.querySelector(`option[data-key="${CSS.escape(wanted)}"]`);
      if (option) select.value = option.value;

      const status = form.querySelector('[data-status]');
      const outcome = status?.dataset.outcome;
      if (outcome === 'error') {
        let draft = {};
        try {
          draft = JSON.parse(sessionStorage.getItem(DRAFT)) || {};
        } catch {}
        for (const [name, value] of Object.entries(draft)) {
          const field = form.elements.namedItem(name);
          if (!field || field.type === 'hidden') continue;
          // Shopify's own values (email, message) win; the visitor's choice
          // of service wins over the one a link preselected.
          if (field.tagName === 'SELECT' || !field.value) field.value = value;
        }
      } else if (outcome === 'sent') {
        try {
          sessionStorage.removeItem(DRAFT);
        } catch {}
      }
      if (status && !status.hidden) status.focus();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setUpContactForms);
  } else {
    setUpContactForms();
  }
  document.addEventListener('shopify:section:load', setUpContactForms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // The phone menu: the button opens and closes it, and so do Escape and a
  // click anywhere outside it.
  const setMenu = (button, open) => {
    button.setAttribute('aria-expanded', String(open));
    document.getElementById(button.getAttribute('aria-controls'))?.classList.toggle('is-open', open);
  };
  const openMenus = () => document.querySelectorAll('[data-menu-toggle][aria-expanded="true"]');

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-menu-toggle]');
    if (button) {
      setMenu(button, button.getAttribute('aria-expanded') !== 'true');
      return;
    }
    openMenus().forEach((open) => {
      const menu = document.getElementById(open.getAttribute('aria-controls'));
      if (!menu?.contains(event.target)) setMenu(open, false);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    openMenus().forEach((open) => {
      setMenu(open, false);
      open.focus();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
